module.exports = "\n<span class=\"span1\">{{(minutesDisplay) && (minutesDisplay <= 59) ? minutesDisplay : '00'}}</span> : <span class=\"span2\">{{(secondsDisplay) && (secondsDisplay <= 59) ? secondsDisplay : '00'}}</span>\n      "


//////////////////
// WEBPACK FOOTER
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/layout/components/header/timers/timers.component.html
// module id = ../../../../../src/app/layout/components/header/timers/timers.component.html
// module chunks = main